module.exports = __webpack_public_path__ + "images/index/home.f80b75e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/chenmei/home.jpg
// module id = 6V4g
// module chunks = 21